import { render, staticRenderFns } from "./ConfirmNewReportCreationModal.vue?vue&type=template&id=5e8dfa3b&scoped=true&"
import script from "./ConfirmNewReportCreationModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmNewReportCreationModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmNewReportCreationModal.vue?vue&type=style&index=0&id=5e8dfa3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8dfa3b",
  null
  
)

export default component.exports